import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './UpcomingCoursePage.css';
import HeroSection from './components/HeroSection/HeroSection';
import SyllabusSection from './components/SyllabusSection/SyllabusSection';
import ScheduleSection from './components/ScheduleSection/ScheduleSection';
import FeesSection from './components/FeesSection/FeesSection';
import RoadmapSection from './components/RoadmapSection/RoadmapSection';
import LogicBuildSection from './components/LogicBuildSection/LogicBuildSection';
import QuizSection from './components/QuizSection/QuizSection';
import AptitudeSection from './components/AptitudeSection/AptitudeSection';
import QuizeethonSection from './components/QuizeethonSection/QuizeethonSection';
import SuperXSection from './components/SuperXSection/SuperXSection';
import StudentProjectsSection from './components/StudentProjectsSection/StudentProjectsSection';
import CertificationSection from './components/CertificationSection/CertificationSection';
import RulesSection from './components/RulesSection/RulesSection';
import AnalyticsSection from './components/AnalyticsSection/AnalyticsSection';
import EnrollmentModal from './components/EnrollmentModal/EnrollmentModal';
import Footer from '../c2wHomePage/Footer';

const UpcomingCoursePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showInternshipLetter, setShowInternshipLetter] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Enable window scrolling by overriding global styles in index.css
    const originalHtmlHeight = document.documentElement.style.height;
    const originalBodyHeight = document.body.style.height;
    
    document.documentElement.style.height = 'auto';
    document.documentElement.style.overflowY = 'visible';
    document.body.style.height = 'auto';
    document.body.style.overflowY = 'visible';
    
    return () => {
      // Restore original styles on unmount
      document.documentElement.style.height = originalHtmlHeight;
      document.documentElement.style.overflowY = 'auto';
      document.body.style.height = originalBodyHeight;
      document.body.style.overflowY = 'auto';
    };
  }, []);

  return (
    <div className="ucp-master-container">
      <HeroSection onEnrollClick={openModal} />
      <RoadmapSection />
      <SyllabusSection />
      <LogicBuildSection onEnrollClick={openModal} />
      <QuizSection />
      <AptitudeSection />
      <QuizeethonSection />
      <SuperXSection />
      <StudentProjectsSection />
      <AnalyticsSection />
      <ScheduleSection />
      <FeesSection onEnrollClick={openModal} />
      <CertificationSection />

      {/* Internship Highlight Banner */}
      <motion.div 
        className="ucp-internship-banner"
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, margin: "-50px" }}
        whileHover={{ scale: 1.03 }}
        transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}
        onClick={() => setShowInternshipLetter(true)}
      >
        <div className="ucp-internship-content">
          <div className="ucp-internship-text">
            <h3>
              <motion.span 
                display="inline-block"
                animate={{ rotate: [0, 15, -15, 0] }}
                transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
                style={{ display: "inline-block", marginRight: "8px" }}
              >
                🌟
              </motion.span> 
              Internship Opportunity
            </h3>
            <p>The internship letter will be provided in this course upon successful completion.</p>
            <span className="view-letter-prompt">Click to view sample letter &rarr;</span>
          </div>
          <div className="ucp-internship-image-preview">
            <img src="/assets/images/upcomingCourse/internship_letter.png" alt="Internship Letter Preview" />
          </div>
        </div>
      </motion.div>

      {/* Internship Letter Modal */}
      <AnimatePresence>
        {showInternshipLetter && (
          <motion.div 
            className="ucp-letter-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowInternshipLetter(false)}
          >
            <motion.div 
              className="ucp-letter-modal-content"
              initial={{ scale: 0.8, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="ucp-close-letter" onClick={() => setShowInternshipLetter(false)}>&times;</button>
              <img src="/assets/images/upcomingCourse/internship_letter.png" alt="Internship Completion Letter" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <RulesSection />
      <div className="ADfooter__container">
        <Footer />
      </div>
      <EnrollmentModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default UpcomingCoursePage;
